import { useQuery } from "@tanstack/react-query";
import { getContentBlockerTemplateStatistics } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Read content blocker statistics via RCB ContentBlocker API.
 */ function useContentBlockerTemplateStatistics(favouritesOnly = false) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.getContentBlockerStatistics(favouritesOnly), ({ signal })=>getContentBlockerTemplateStatistics({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                favouritesOnly
            }
        }), {
        retry: false,
        refetchOnMount: true
    });
}
export { useContentBlockerTemplateStatistics };
